import React from 'react';
import { Box } from '@mui/material';
//import CommentList from '../../common/comment/CommentList';
import SalesForecastList from '../../salesActionStat/SalesForecastList';
const SalesActivityTemplate = () => {
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <SalesForecastList />
    </Box>
  );
};

export default SalesActivityTemplate;
